export const FETCH_SALES_RESTAURANTS = 'FETCH_SALES_RESTAURANTS';
export const FETCH_SALES_RESTAURANTS_SUCCESS = 'FETCH_SALES_RESTAURANTS_SUCCESS';
export const FETCH_SALES_RESTAURANTS_FAIL = 'FETCH_SALES_RESTAURANTS_FAIL';

export const FETCH_SALES_ANALYTICS = 'FETCH_SALES_ANALYTICS';
export const FETCH_SALES_ANALYTICS_SUCCESS = 'FETCH_SALES_ANALYTICS_SUCCESS';
export const FETCH_SALES_ANALYTICS_FAIL = 'FETCH_SALES_ANALYTICS_FAIL';
export const FETCH_SALES_ANALYTICS_SKIP = 'FETCH_SALES_ANALYTICS_SKIP';

export const SET_SALES_ANALYTICS_FILTERS = 'SET_SALES_ANALYTICS_FILTERS';
export const CLEAR_SALES_ANALYTICS = 'CLEAR_SALES_ANALYTICS';

export const fetchSalesRestaurants = (payload = {}) => ({
  type: FETCH_SALES_RESTAURANTS,
  payload,
});

export const fetchSalesRestaurantsSuccess = (payload) => ({
  type: FETCH_SALES_RESTAURANTS_SUCCESS,
  payload,
});

export const fetchSalesRestaurantsFail = (error) => ({
  type: FETCH_SALES_RESTAURANTS_FAIL,
  payload: error,
});

export const fetchSalesAnalytics = (payload) => ({
  type: FETCH_SALES_ANALYTICS,
  payload,
});

export const fetchSalesAnalyticsSuccess = (payload) => ({
  type: FETCH_SALES_ANALYTICS_SUCCESS,
  payload,
});

export const fetchSalesAnalyticsFail = (error) => ({
  type: FETCH_SALES_ANALYTICS_FAIL,
  payload: error,
});

export const fetchSalesAnalyticsSkip = () => ({
  type: FETCH_SALES_ANALYTICS_SKIP,
});

export const setSalesAnalyticsFilters = (payload) => ({
  type: SET_SALES_ANALYTICS_FILTERS,
  payload,
});

export const clearSalesAnalytics = () => ({
  type: CLEAR_SALES_ANALYTICS,
});
